'use client'

import { Card, Cell, Spacer, Text } from '@vinted/web-ui'
import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { ErrorState } from '@marketplace-web/error-display/error-display-feature'
import {
  getPrivateBetaTermsOfUseContent,
  transformBusinessAccountsTermsOfUseResponse,
} from '@marketplace-web/business-accounts/business-accounts-data'

const PrivateBetaTermsOfUse = () => {
  const {
    fetch: fetchPrivateBetaTermsOfUse,
    transformedData: termsOfUseContent,
    isLoading,
    error,
  } = useFetch(getPrivateBetaTermsOfUseContent, transformBusinessAccountsTermsOfUseResponse)

  useEffect(() => {
    fetchPrivateBetaTermsOfUse()
  }, [fetchPrivateBetaTermsOfUse])

  const renderBannerContent = termsUpdates => {
    return (
      <div className="u-ui-padding-x2-large@desktops">
        <Text as="h1" type="heading">
          {termsUpdates.title}
        </Text>
        <div className="u-desktops-only">
          <Spacer size="x-large" />
        </div>
        <div className="u-mobiles-only">
          <Spacer size="medium" />
        </div>
        <div>
          <Text as="span" html>
            {termsUpdates.body}
          </Text>
        </div>
      </div>
    )
  }

  const renderBanner = () => {
    if (!termsOfUseContent?.terms_updates) return null

    const { terms_updates } = termsOfUseContent

    return (
      <div>
        <div className="u-desktops-only">
          <Spacer size="x2-large" />
          <Card styling="elevated">{renderBannerContent(terms_updates)}</Card>
        </div>
        <div className="u-mobile-only">
          <Spacer size="x-large" />
          <Card>{renderBannerContent(terms_updates)}</Card>
          <Spacer size="x4-large" />
        </div>
      </div>
    )
  }

  if (error) return <ErrorState />
  if (isLoading || !termsOfUseContent)
    return (
      <ContentLoader styling={ContentLoader.Styling.Wide} testId="private-terms-of-use-loader" />
    )

  return (
    <Cell styling="wide">
      {renderBanner()}
      <Text as="h1" type="heading">
        {termsOfUseContent.title}
      </Text>
      <Spacer size="x-large" />
      <div className="user-created-content">
        <Text as="span" html>
          {termsOfUseContent.body}
        </Text>
      </div>
    </Cell>
  )
}

export default PrivateBetaTermsOfUse
